module.exports = __webpack_public_path__ + "img/dashboard_icon.543d9f18.svg";